import { ConsoleLogger, RollbarLogger, LoggerType } from '@dx/common';

import { ConfigService } from '../services/config.service';

/**
 * App isn't using a static config so it will use its own factory to provide Logger
 * instead of using LoggerModule.forRoot(logConfig)
 */
export const loggerFactory = (configService: ConfigService) => {
  const logConfig = configService.config.logConfig;
  switch (logConfig.type) {
    case LoggerType.Rollbar:
      return new RollbarLogger(logConfig);
    default:
      return new ConsoleLogger(logConfig);
  }
};
